import { Skeleton, SkeletonList } from "@aviary";

import * as styles from "./SkeletonShopDropdown.styles";

const SkeletonShopDropdown = () => {
  return (
    <div css={styles.skeletons}>
      <SkeletonList number={7}>
        <Skeleton type="typography" isFullWidth />
      </SkeletonList>
    </div>
  );
};

export { SkeletonShopDropdown };
